import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LabelComponent } from '@fc-shared/ui/input/core/label/label.component';
import { FormFieldComponent } from '@fc-shared/ui/input/core/form-field/form-field.component';
import { InputDirective } from '@fc-shared/ui/input/core/input.directive';
import { PrefixDirective } from '@fc-shared/ui/input/core/prefix.directive';
import { ErrorComponent } from '@fc-core/form-utils/form-error/error.component';
import { SuffixDirective } from '@fc-shared/ui/input/core/suffix.directive';

@NgModule({
  imports: [
    CommonModule,
    LabelComponent,
    FormFieldComponent,
    InputDirective,
    PrefixDirective,
    ErrorComponent,
    SuffixDirective,
  ],
  exports: [
    LabelComponent,
    FormFieldComponent,
    InputDirective,
    PrefixDirective,
    ErrorComponent,
    SuffixDirective,
  ],
})
export class CoreInputModule {}
